import { render, staticRenderFns } from "./order-form.vue?vue&type=template&id=3bc238a8&scoped=true"
import script from "./order-form.vue?vue&type=script&lang=js"
export * from "./order-form.vue?vue&type=script&lang=js"
import style0 from "./order-form.vue?vue&type=style&index=0&id=3bc238a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a947b4d37137bf79d4abbd1caef86e24/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc238a8",
  null
  
)

export default component.exports